import React from 'react';

export const arrowDownOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M19.7409 12.4681C19.421 12.1437 18.9155 12.1132 18.5609 12.3792L18.4681 12.4591L12.9 17.95L12.9 3.9C12.9 3.40294 12.4971 3 12 3C11.5412 3 11.1625 3.34334 11.107 3.78711L11.1 3.9V17.95L5.53187 12.4591C5.20741 12.1392 4.70155 12.116 4.3507 12.3869L4.25911 12.4681C3.93922 12.7926 3.91596 13.2985 4.18694 13.6493L4.26813 13.7409L11.3681 20.7409C11.6893 21.0576 12.1891 21.084 12.5401 20.8201L12.6319 20.7409L19.7319 13.7409C20.0858 13.3919 20.0899 12.8221 19.7409 12.4681Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const arrowLeftOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M11.5319 19.7409C11.8563 19.421 11.8868 18.9155 11.6208 18.5609L11.5409 18.4681L6.05 12.9L20.1 12.9C20.5971 12.9 21 12.4971 21 12C21 11.5412 20.6567 11.1625 20.2129 11.107L20.1 11.1L6.05 11.1L11.5409 5.53187C11.8608 5.20741 11.884 4.70155 11.6131 4.3507L11.5319 4.2591C11.2074 3.93922 10.7016 3.91595 10.3507 4.18693L10.2591 4.26813L3.25911 11.3681C2.94242 11.6893 2.91603 12.1891 3.17994 12.5401L3.25911 12.6319L10.2591 19.7319C10.6081 20.0858 11.1779 20.0899 11.5319 19.7409Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const arrowPopDownOutline = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21 21C22.6569 21 24 19.6569 24 18V7C24 5.34315 22.6569 4 21 4H10C8.34315 4 7 5.34315 7 7L7 18C7 19.6569 8.34315 21 10 21L21 21ZM21 19L15.5 19L10 19C9.44772 19 9 18.5523 9 18L9 7C9 6.44772 9.44772 6 10 6L21 6C21.5523 6 22 6.44772 22 7V18C22 18.5523 21.5523 19 21 19ZM17 25C18.3063 25 19.4175 24.1651 19.8293 22.9999L10.1278 23C8.34473 23 7.69816 22.8143 7.04631 22.4657C6.39446 22.1171 5.88288 21.6055 5.53427 20.9537C5.18565 20.3018 5 19.6552 5 17.8722L5.00009 9.17065C3.83485 9.58247 3 10.6937 3 12V19C3 22.3137 5.68629 25 9 25L17 25ZM19.2067 10.2095C19.5978 9.81843 19.5978 9.18438 19.2067 8.7933C18.8156 8.40223 18.1816 8.40223 17.7905 8.7933L14.0028 12.581L14.0028 10.3338C14.0028 9.78074 13.5545 9.3324 13.0014 9.3324C12.4483 9.3324 12 9.78074 12 10.3338L12 14.9976L12 15.0078C12.0024 15.2601 12.0994 15.5117 12.2912 15.7046L12.2933 15.7067L12.2954 15.7088C12.3909 15.8038 12.5008 15.8755 12.6181 15.924C12.7335 15.9719 12.8597 15.9988 12.9922 16L13.0024 16H17.6662C18.2193 16 18.6676 15.5517 18.6676 14.9986C18.6676 14.4455 18.2193 13.9972 17.6662 13.9972H15.419L19.2067 10.2095Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const arrowPopUpOutline = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21 21C22.6569 21 24 19.6569 24 18V7C24 5.34315 22.6569 4 21 4H10C8.34315 4 7 5.34315 7 7L7 18C7 19.6569 8.34315 21 10 21L21 21ZM21 19L15.5 19L10 19C9.44772 19 9 18.5523 9 18L9 7C9 6.44772 9.44772 6 10 6L21 6C21.5523 6 22 6.44772 22 7V18C22 18.5523 21.5523 19 21 19ZM17 25C18.3063 25 19.4175 24.1651 19.8293 22.9999L10.1278 23C8.34473 23 7.69816 22.8143 7.04631 22.4657C6.39446 22.1171 5.88288 21.6055 5.53427 20.9537C5.18565 20.3018 5 19.6552 5 17.8722L5.00009 9.17065C3.83485 9.58247 3 10.6937 3 12V19C3 22.3137 5.68629 25 9 25L17 25ZM12.2933 14.2905C11.9022 14.6816 11.9022 15.3156 12.2933 15.7067C12.6844 16.0978 13.3184 16.0978 13.7095 15.7067L17.4972 11.919V14.1662C17.4972 14.7193 17.9455 15.1676 18.4986 15.1676C19.0517 15.1676 19.5 14.7193 19.5 14.1662V9.50241L19.5 9.49216C19.4976 9.2399 19.4006 8.98834 19.2088 8.79543L19.2067 8.7933L19.2046 8.79118C19.1091 8.69623 18.9992 8.62449 18.8819 8.57599C18.7665 8.52814 18.6403 8.50124 18.5078 8.50004L18.4976 8.5L13.8338 8.5C13.2807 8.5 12.8324 8.94834 12.8324 9.5014C12.8324 10.0545 13.2807 10.5028 13.8338 10.5028L16.081 10.5028L12.2933 14.2905Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const arrowRightCircleOutline = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M8 14C8 13.4477 8.44772 13 9 13H16.5858L14.2929 10.7071C13.9024 10.3166 13.9024 9.68342 14.2929 9.29289C14.6834 8.90237 15.3166 8.90237 15.7071 9.29289L19.7071 13.2929C20.0976 13.6834 20.0976 14.3166 19.7071 14.7071L15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071C13.9024 18.3166 13.9024 17.6834 14.2929 17.2929L16.5858 15H9C8.44772 15 8 14.5523 8 14Z'
        fill='#023F80'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 14C2 7.37258 7.37258 2 14 2C20.6274 2 26 7.37258 26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14ZM14 4C8.47715 4 4 8.47715 4 14C4 19.5228 8.47715 24 14 24C19.5228 24 24 19.5228 24 14C24 8.47715 19.5228 4 14 4Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const arrowRightOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12.4681 4.25911C12.1437 4.579 12.1132 5.08447 12.3792 5.43913L12.4591 5.53187L17.95 11.1L3.9 11.1C3.40294 11.1 3 11.5029 3 12C3 12.4588 3.34334 12.8375 3.78711 12.893L3.9 12.9H17.95L12.4591 18.4681C12.1392 18.7926 12.116 19.2984 12.3869 19.6493L12.4681 19.7409C12.7926 20.0608 13.2985 20.084 13.6493 19.8131L13.7409 19.7319L20.7409 12.6319C21.0576 12.3107 21.084 11.8109 20.8201 11.4599L20.7409 11.3681L13.7409 4.26813C13.3919 3.91418 12.8221 3.91014 12.4681 4.25911Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const arrowRightSquareOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M14.5904 2.09998C16.7583 2.09998 17.7924 2.29968 18.8666 2.87418C19.8383 3.39382 20.6062 4.16177 21.1259 5.13342C21.7004 6.20764 21.9001 7.24178 21.9001 9.40969V14.5903C21.9001 16.7582 21.7004 17.7923 21.1259 18.8665C20.6062 19.8382 19.8383 20.6061 18.8666 21.1258C17.7924 21.7003 16.7583 21.9 14.5904 21.9H9.40981C7.2419 21.9 6.20776 21.7003 5.13354 21.1258C4.16189 20.6061 3.39395 19.8382 2.8743 18.8665C2.2998 17.7923 2.1001 16.7582 2.1001 14.5903V9.40969C2.1001 7.24178 2.2998 6.20764 2.8743 5.13342C3.39395 4.16177 4.16189 3.39382 5.13354 2.87418C6.20776 2.29968 7.2419 2.09998 9.40981 2.09998H14.5904ZM14.5904 3.89998H9.40981C7.51364 3.89998 6.76022 4.04547 5.98242 4.46144C5.32445 4.81333 4.81345 5.32433 4.46156 5.9823C4.04559 6.7601 3.9001 7.51351 3.9001 9.40969V14.5903C3.9001 16.4864 4.04559 17.2398 4.46156 18.0177C4.81345 18.6756 5.32445 19.1866 5.98242 19.5385C6.76022 19.9545 7.51364 20.1 9.40981 20.1H14.5904C16.4866 20.1 17.24 19.9545 18.0178 19.5385C18.6757 19.1866 19.1867 18.6756 19.5386 18.0177C19.9546 17.2398 20.1001 16.4864 20.1001 14.5903V9.40969C20.1001 7.51351 19.9546 6.7601 19.5386 5.9823C19.1867 5.32433 18.6757 4.81333 18.0178 4.46144C17.24 4.04547 16.4866 3.89998 14.5904 3.89998ZM12.309 8.2213C12.6838 7.89485 13.2523 7.93405 13.5788 8.30887L16.2788 11.4089C16.5739 11.7477 16.5739 12.2523 16.2788 12.5911L13.5788 15.6911C13.2523 16.0659 12.6838 16.1051 12.309 15.7786C11.9342 15.4522 11.895 14.8837 12.2214 14.5089L13.6221 12.9H8.4001C7.94128 12.9 7.56265 12.5566 7.50711 12.1129L7.5001 12C7.5001 11.5029 7.90304 11.1 8.4001 11.1H13.6221L12.2214 9.49108C11.9222 9.14749 11.9302 8.64116 12.2223 8.30771L12.309 8.2213Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const arrowUpCircleOutline = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14 4C8.47715 4 4 8.47715 4 14C4 19.5228 8.47715 24 14 24C19.5228 24 24 19.5228 24 14C24 8.47715 19.5228 4 14 4ZM2 14C2 7.37258 7.37258 2 14 2C20.6274 2 26 7.37258 26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14ZM13 11.4142L10.7071 13.7071C10.3166 14.0976 9.68342 14.0976 9.29289 13.7071C8.90237 13.3166 8.90237 12.6834 9.29289 12.2929L13.2929 8.29288C13.6834 7.90235 14.3166 7.90235 14.7071 8.29288L18.7071 12.2929C19.0976 12.6834 19.0976 13.3166 18.7071 13.7071C18.3166 14.0976 17.6834 14.0976 17.2929 13.7071L15 11.4142V19C15 19.5523 14.5523 20 14 20C13.4477 20 13 19.5523 13 19V11.4142Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const arrowUpOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M11.3681 3.25911C11.7185 2.91363 12.2815 2.91363 12.6319 3.25911L19.7319 10.2591C20.0858 10.6081 20.0899 11.1779 19.7409 11.5319C19.3919 11.8858 18.8221 11.8899 18.4681 11.5409L12.9 6.05118V20.1C12.9 20.5971 12.4971 21 12 21C11.5029 21 11.1 20.5971 11.1 20.1V6.05119L5.53187 11.5409C5.17791 11.8899 4.60808 11.8858 4.25911 11.5319C3.91014 11.1779 3.91418 10.6081 4.26813 10.2591L11.3681 3.25911Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const arrowUpRectangleOutline = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.06946 4.8014C6.16477 4.21562 7.24388 4 9.69166 4H18.3083C20.7561 4 21.8352 4.21562 22.9305 4.8014C23.9057 5.32294 24.6771 6.09426 25.1986 7.06946C25.7844 8.16477 26 9.24388 26 11.6917V16.3083C26 18.7561 25.7844 19.8352 25.1986 20.9305C24.6771 21.9057 23.9057 22.6771 22.9305 23.1986C21.8352 23.7844 20.7561 24 18.3083 24H9.69166C7.24388 24 6.16477 23.7844 5.06946 23.1986C4.09426 22.6771 3.32294 21.9057 2.8014 20.9305C2.21562 19.8352 2 18.7561 2 16.3083V11.6917C2 9.24388 2.21562 8.16477 2.8014 7.06946C3.32294 6.09426 4.09426 5.32294 5.06946 4.8014ZM9.69166 6C7.35671 6 6.67339 6.21166 6.01266 6.56502C5.386 6.90017 4.90017 7.386 4.56502 8.01266C4.21166 8.67339 4 9.35671 4 11.6917V16.3083C4 18.6433 4.21166 19.3266 4.56502 19.9873C4.90017 20.614 5.386 21.0998 6.01266 21.435C6.67339 21.7883 7.35671 22 9.69166 22H18.3083C20.6433 22 21.3266 21.7883 21.9873 21.435C22.614 21.0998 23.0998 20.614 23.435 19.9873C23.7883 19.3266 24 18.6433 24 16.3083V11.6917C24 9.35671 23.7883 8.67339 23.435 8.01266C23.0998 7.386 22.614 6.90017 21.9873 6.56502C21.3266 6.21166 20.6433 6 18.3083 6H9.69166Z'
        fill='#023F80'
      />
      <path
        d='M13 18C13 18.5523 13.4477 19 14 19C14.5523 19 15 18.5523 15 18V12.4142L16.2929 13.7071C16.6834 14.0976 17.3166 14.0976 17.7071 13.7071C18.0976 13.3166 18.0976 12.6834 17.7071 12.2929L14.7071 9.29289C14.3166 8.90237 13.6834 8.90237 13.2929 9.29289L10.2929 12.2929C9.90237 12.6834 9.90237 13.3166 10.2929 13.7071C10.6834 14.0976 11.3166 14.0976 11.7071 13.7071L13 12.4142V18Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const arrowUturnLeftOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.2365 3.2636C10.588 3.61508 10.588 4.18492 10.2365 4.5364L7.67289 7.1H12.0001C15.2586 7.1 17.9001 9.74152 17.9001 13C17.9001 16.2585 15.2586 18.9 12.0001 18.9H7.9001C7.40304 18.9 7.0001 18.4971 7.0001 18C7.0001 17.5029 7.40304 17.1 7.9001 17.1H12.0001C14.2645 17.1 16.1001 15.2644 16.1001 13C16.1001 10.7356 14.2645 8.9 12.0001 8.9H7.6729L10.2365 11.4636C10.588 11.815 10.588 12.3849 10.2365 12.7364C9.88502 13.0878 9.31518 13.0878 8.9637 12.7364L4.8637 8.6364C4.69492 8.46762 4.6001 8.2387 4.6001 8C4.6001 7.76131 4.69492 7.53239 4.8637 7.3636L8.9637 3.2636C9.31517 2.91213 9.88502 2.91213 10.2365 3.2636Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const arrowUturnRightOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.7637 3.2636C14.1152 2.91213 14.685 2.91213 15.0365 3.2636L19.1365 7.3636C19.3053 7.53239 19.4001 7.76131 19.4001 8C19.4001 8.2387 19.3053 8.46762 19.1365 8.6364L15.0365 12.7364C14.685 13.0878 14.1152 13.0878 13.7637 12.7364C13.4122 12.3849 13.4122 11.815 13.7637 11.4636L16.3273 8.9H12.0001C9.73573 8.9 7.9001 10.7356 7.9001 13C7.9001 15.2644 9.73573 17.1 12.0001 17.1H16.1001C16.5972 17.1 17.0001 17.5029 17.0001 18C17.0001 18.4971 16.5972 18.9 16.1001 18.9H12.0001C8.74162 18.9 6.1001 16.2585 6.1001 13C6.1001 9.74152 8.74162 7.1 12.0001 7.1H16.3273L13.7637 4.5364C13.4122 4.18492 13.4122 3.61508 13.7637 3.2636Z'
        fill='#023F80'
      />
    </svg>
  );
};
